/**
 * Created by desheng.zhao on 2018/7/16.
 */
export default function (url) {
    if(!url){
        console.warn("缺少url参数");
        return ;
    }
    var oA = document.createElement("a");
    oA.target = '_self';
    oA.href = url;
    var oSpan = document.createElement('span');
    oSpan.innerText = '跳转';
    oA.append(oSpan);
    oA.style.display = "none";
    document.body.append(oA);
    // oA.click();
    oSpan.click();
    oA.remove();
}


// WEBPACK FOOTER //
// ./src/utils/location.js